import { Seo } from "@/components/Seo";
import { Reveal, PageHero } from "@/components/shared";

const markers = [
  "30+ ans d'expérience entrepreneuriale",
  "Conception et structuration de projets",
  "Analyse, mise en système et pilotage",
];

export default function APropos() {
  return (
    <>
      <Seo
        title="À propos — BENZENATI"
        description="Une expérience entrepreneuriale devenue espace de réflexion. BENZENATI est un Atelier indépendant de veille, de décryptage et de mise en perspective pour les PME."
      />
      <PageHero
        label="À propos"
        title="Une expérience entrepreneuriale devenue espace de réflexion"
        testid="apropos-hero"
      />

      <section className="mx-auto max-w-3xl px-6 py-20 lg:py-28" data-testid="apropos-content">
        <Reveal>
          <p className="text-lg leading-loose text-bz-slate">
            Mohamed Benzenati développe depuis plus de trente ans des projets, concepts, dispositifs commerciaux et outils de pilotage. Son parcours d'entrepreneur indépendant l'a conduit à observer des secteurs, des organisations et des modèles économiques très différents.
          </p>
          <p className="mt-8 text-lg leading-loose text-bz-slate">
            BENZENATI prolonge cette expérience sous la forme d'un Atelier de veille, de décryptage et de mise en perspective. Sa vocation n'est pas d'apporter des réponses toutes faites, mais d'aider à mieux formuler les questions, relier les informations et comprendre les transformations qui concernent les PME.
          </p>
        </Reveal>
      </section>

      <section className="border-t border-bz-line bg-bz-ivory2" data-testid="apropos-markers">
        <div className="mx-auto max-w-7xl px-6 py-20 lg:px-10 lg:py-24">
          <div className="grid grid-cols-1 gap-px overflow-hidden border border-bz-line bg-bz-line md:grid-cols-3">
            {markers.map((m, i) => (
              <Reveal key={m} delay={i * 0.1} className="bg-white">
                <div className="flex h-full items-center p-10" data-testid={`apropos-marker-${i}`}>
                  <p className="font-serif text-2xl leading-snug text-bz-navy">{m}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
